export const SET_OPERATIONS = 'SET_OPERATIONS';
export const LOAD_OPERATIONS = 'LOAD_OPERATIONS';


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/types.js